import React from 'react';
import Image from '../assets/fusee1.png';
import { FaInstagram , FaTwitter , FaGithub } from 'react-icons/fa';
import { TypeAnimation } from 'react-type-animation';
import { fadeIn } from '../variants';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';



const Banner = () => {
  const email = 'merlinmap502@gmail.com';


  return (
    <section className='min-h-[85vh] lg:min-h-[78vh] flex items-center' id='home'>

<div className="container mx-auto">




  <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>
  <div className='flex-1 text-center font-secondary lg:text-left '>
    <motion.h1 variants={fadeIn('up, 0.4')} initial="hidden" whileInView={'show'} viewport={{once: false, amount:0.7}}
     className='text-[55px] font-bold leading-[0.8] lg:text-[110px]'><span className='text-custom-blue mr-4'>I'M </span>HYAWE-H</motion.h1>


  <motion.div 
  variants={fadeIn('up', '0.4')}
  initial="hidden"
  whileInView={'show'}
  viewport={{once: false, amount: 0.7 }}
  className='mb-6 text-[36px] lg:text-[40px] font-secondary 
  font-semibold uppercase leading-[1]'>

   <span className='text-white mr-4'></span>
     <TypeAnimation sequence={[
         'A Software-Developer',
          0,



     ]}
speed={50}  
className='text-accent'
wrapper='span'
repeat={Infinity} 
     />
</motion.div>


     <motion.p 
     variants={fadeIn('up' , 0.5)}
     initial='hidden'
     whileInView={'show'}
     viewport={{ once: false, amount: 0.7 }}
     className='mb-8 max-w-lg mx-auto lg:mx-0'>

      </motion.p>

<motion.div
 variants={fadeIn('up' , 0.6)}
 initial='hidden'
 whileInView={'show'}
 viewport={{ once: false, amount: 0.7 }}
className='flex max-w-max gap-x-6 items-center mb-12
mx-auto lg:mx-0'>













 </motion.div>


 <div className='flex text-[40px] gap-x-6 max-w-max mx-auto
 lg:mx-0'> 

  <a href="https://github.com/Mapatano">
    <FaGithub />
  </a>
  <a href="https://twitter.com/Map5_H">
    <FaTwitter />
  </a>
</div>
</div>


  <motion.div
   variants={fadeIn('down' , 0.5)}
   initial='hidden'
   whileInView={'show'}
   
  className='hidden lg:flex flex-1 max-w-[160px] lg:max-w-[412px]
  '>
<img src={Image} alt='' />
  </motion.div>


  </div>


</div>

</section>
);};

export default Banner;
